// src/pages/user/Hotels/FloorPlansPage.jsx
import React from 'react';

const FloorPlansPage = () => {
  return (
    <div>
      <h1>Floor Plans</h1>
      <p>Manage floor plans here.</p>
    </div>
  );
};

export default FloorPlansPage;
